<template>
  <div class="row pt-4">
    <div class="col-12">
      <div>
        <div class="row">
          <div class="col-4">
            <label class="rights">{{ $t('rights') | capitalize }}</label>
          </div>
          <div class="col-1 vcenter">
            <label class="label-text pull-left">{{ $t('domestic') | capitalize }}</label>
          </div>
          <div class="col-1 vcenter">
            <label class="label-text pull-left">{{ $t('worldwide') | capitalize }}</label>
          </div>
        </div>

        <div
          v-for="(mandate, index) in mandates"
          :key="mandate.name"
          class="row p-1"
          :class="{'line': index !== mandates.length - 1}"
        >
          <div
            class="col-4 vcenter mandate-name"
            :class="{'disabled': !mandate.has_agreement}"
          >
            {{ mandate.name }}
          </div>

          <div class="col-1 text-center vcenter">
            <p-check
              v-model="mandate.domestic"
              class="p-icon p-square"
              color="success"
              :disabled="isBasic || !mandate.has_agreement"
              @change="checkmandates(mandate.name,'domestic')"
            >
              <template v-slot:extra>
                <i class="icon fa fa-check"/>
              </template>
            </p-check>
          </div>

          <div class="col-1 text-center vcenter">
            <p-check
              v-model="mandate.worldwide"
              class="p-icon p-square"
              color="success"
              :disabled="isBasic || !mandate.has_agreement"
              @change="checkmandates(mandate.name,'worldwide')"
            >
              <template v-slot:extra>
                <i class="icon fa fa-check"/>
              </template>
            </p-check>
          </div>

          <div class="col-1 vcenter">
            <span class="mandate-mode">{{ getMandateModeValue(mandate) }}</span>
          </div>

          <div class="col-5 vcenter">
            <div class="search-countries">
              <i class="fa fa-search" />
            </div>
            <Multiselect
              v-model="mandate.countries"
              :disabled="!(mandate.worldwide || mandate.domestic) || !mandate.has_agreement"
              :options="countries"
              :multiple="true"
              label="name"
              track-by="name"
              :hide-selected="true"
              :show-labels="false"
              placeholder
            />
          </div>
        </div>

        <div style="height:50px;" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.vcenter {
  display: flex;
  align-items: center;
}

.search-countries {
  width: 20px;
  position: absolute;
  left: -10px;
  top: 10px;
  color: #f2f2f2;
}

.mandate-mode {
  color: var(--gray);
}

input {
  height: 48px;
  padding: 6px;
  color: black;
  border: 1px solid #c0c5cf;
  border-radius: 4px;
}

a.pointer {
  color: lightskyblue;

  &:hover {
    color: rgba(0, 0, 0, 0.54);
  }
}

.rights {
  height: 45px;
  width: 370px;
  color: #000;
  font-family: "CircularStd", sans-serif;
  font-size: 26px;
  font-weight: 500;
  line-height: 33px;
}

.mandate-name {
  color: rgba(0, 0, 0, 0.87);
  font-family: "CircularStd", sans-serif;
  font-size: 16px;
  font-weight: 300;

  &.disabled {
    color: rgba(0, 0, 0, 0.2);
  }
}
</style>
<script>
import { mapGetters } from "vuex"

export default {
  name: "MandatesSelector",
  props: ["mandates"],
  computed: {
    ...mapGetters("soundsys", ["isBasic", "countries"])
  },
  methods: {
    getMandateModeValue (mandate) {
      if (mandate.worldwide) {
        return "but"
      } else if (mandate.domestic) {
        return "and"
      }
    },
    checkmandates (name, scope) {
      let mandate = this.mandates.filter(x => x.name === name)[0]
      let val = mandate[scope]

      if (val) {
        let otherscope = scope === "domestic" ? "worldwide" : "domestic"
        mandate[otherscope] = false
      }
    }
  }
}
</script>
